import * as yup from 'yup';
import { IFormSelectOption } from '../../../interfaces/forms/forms';
import {validateSsn} from "../../../helpers/formHelpers/formHelpers";

export interface IStepPaymentInfo {
	payerIsForeign: boolean;
	whoToPay: IFormSelectOption;
	ssn: string;
	bank: string;
	accountType: string;
	account: string;
	iban: string;
	swift: string;
}

export const stepPaymentInfoInitalValues: IStepPaymentInfo = {
	payerIsForeign: false,
	whoToPay: null,
	ssn: '',
	bank: '',
	accountType: '',
	account: '',
	iban: '',
	swift: '',
};

const yupFormSelectOption = {
	label: yup.string(),
	value: yup.string(),
};

export const stepPaymentInfoSchema = yup.object().shape({
	whoToPay: yup
		.object()
		.nullable()
		.shape(yupFormSelectOption)
		.required('shared.required'),
	ssn: yup.string().when('payerIsForeign', {
		is: false,
		then: yup.string().required('shared.required').test('is-valid-ssn', 'step-info.ssn-valid', validateSsn),
	}),
	bank: yup.string().when('payerIsForeign', {
		is: false,
		then: yup
			.string()
			.max(4, 'step-info.max')
			.matches(/^[0-9]+$/, 'shared.onlyNumbers')
			.required('shared.required'),
	}),
	accountType: yup
		.string()
		.matches(/^[0-9]+$/, 'shared.onlyNumbers')
		.when('payerIsForeign', {
			is: false,
			then: yup
				.string()
				.required('shared.required')
				.test('length', 'step-optional-services.account-type-length', val => val && val.length === 2),
		}),
	account: yup.string().when('payerIsForeign', {
		is: false,
		then: yup
			.string()
			.max(6, 'step-info.max')
			.matches(/^[0-9]+$/, 'shared.onlyNumbers')
			.required('shared.required'),
	}),
	iban: yup.string().when('payerIsForeign', {
		is: true,
		then: yup.string().required('shared.required'),
	}),
	swift: yup.string().when('payerIsForeign', {
		is: true,
		then: yup.string(),
	}),
});
